import { ALTO_COLORS } from '../alto';

export const ALERT_COLORS = {
  SUCCESS: ALTO_COLORS.PALETTE.SUCCESS.LIGHTEST,
  ERROR: ALTO_COLORS.PALETTE.DANGER.LIGHTEST,
  NEUTRAL: ALTO_COLORS.PALETTE.PRIMARY.LIGHTER,
  WARNING: ALTO_COLORS.PALETTE.WARNING.LIGHTEST,
} as const;
